import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import Topbar from '../layout/Topbar';
import { modificaProfilo, modificaPasswordProfilo } from '../../actions/auth';

const ModificaProfilo = ({ auth: { user, loading }, modificaProfilo, modificaPasswordProfilo }) => {

  const [utente, setUtente] = useState({
    username: '',
    email: ''
  });

  const [passwordData, setPasswordData] = useState({
    nuova_password: '',
    ripeti_password: ''
  });

  const { nuova_password, ripeti_password } = passwordData;


  useEffect(() => {
    setUtente({
      username: loading || !user ? '' : user.username,
      email: loading || !user ? '' : user.email
    })
  }, [user, loading]);

  const { username, email } = utente;

  const onChange = e => setUtente({ ...utente, [e.target.name]: e.target.value });
  const onChangePassword = e => setPasswordData({ ...passwordData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    modificaProfilo({ username, email });
};

const onSubmitPassword = async e => {
  e.preventDefault();
  modificaPasswordProfilo({ nuova_password, ripeti_password });
};

  return (loading ? <Spinner /> :
    <div className="section lightblue user-block wf-section">
      <Topbar 
        labelPagina={"Modifica profilo"}
        isFolder={false}
     />
      <div className="container flex-center">
        <div className="form-wrap wide">
          <div className="form-block w-form">
            <form id="wf-form-registrazione" name="wf-form-registrazione" data-name="registrazione" className="form" aria-label="registrazione" onSubmit={e => onSubmit(e)}>
              <h3 id="w-node-_6aab59d1-f84d-b2bd-8cd4-f48b91ca99db-240c86e7" className="no-margin">I tuoi dati</h3>
              <div id="w-node-_6aab59d1-f84d-b2bd-8cd4-f48b91ca99dd-240c86e7" className="column">
                <label for="username" className="form-label">Username <span className="required">*</span></label>
                <input type="text" className="input-field w-input" maxlength="256" name="username" data-name="username" placeholder="Username" id="username" required="true" value={username} onChange={e => onChange(e)} />
              </div>
              <div id="w-node-_6aab59d1-f84d-b2bd-8cd4-f48b91ca99dd-240c86e7" className="column">
                <label for="email" className="form-label">Email <span className="required">*</span></label>
                <input type="text" className="input-field w-input" maxlength="256" name="email" data-name="email" placeholder="Email" id="email" required="true" value={email} onChange={e => onChange(e)} />
              </div>
              <input type="submit" value="Salva" data-wait="Un attimo..." id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d2b-40413f47" className="submit-button w-button"/>
            </form>
          </div>
        </div>
        <div className="form-wrap wide">
          <div className="form-block w-form">
            <form id="wf-form-registrazione" name="wf-form-registrazione" data-name="registrazione" className="form" aria-label="registrazione" onSubmit={e => onSubmitPassword(e)}>
              <h3 id="w-node-_6aab59d1-f84d-b2bd-8cd4-f48b91ca99db-240c86e7" className="no-margin">Modifica password</h3>
              <div id="w-node-_6aab59d1-f84d-b2bd-8cd4-f48b91ca99dd-240c86e7" className="column">
                <label for="nuova_password" className="form-label">Nuova password <span className="required">*</span></label>
                <input type="password" className="input-field w-input" maxlength="256" name="nuova_password" data-name="nuova_password" placeholder="Inserisci password" id="nuova_password" required="true" value={nuova_password} onChange={e => onChangePassword(e)} />
              </div>
              <div id="w-node-_6aab59d1-f84d-b2bd-8cd4-f48b91ca99dd-240c86e7" className="column">
                <label for="ripeti_password" className="form-label">Ripeti password <span className="required">*</span></label>
                <input type="password" className="input-field w-input" maxlength="256" name="ripeti_password" data-name="ripeti_password" placeholder="Ripeti password" id="ripeti_password" required="true" value={ripeti_password} onChange={e => onChangePassword(e)} />
              </div>
              <input type="submit" value="Salva" data-wait="Un attimo..." id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d2b-40413f47" className="submit-button w-button"/>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
};

ModificaProfilo.propTypes = {
  auth: PropTypes.object.isRequired,
  modificaProfilo: PropTypes.func.isRequired,
  modificaPasswordProfilo: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, { modificaProfilo, modificaPasswordProfilo })(ModificaProfilo);